const SEQ_KEY = 'erp.inventory.discounts.codeSeq.v1'

function bumpSeq(): number {
  try {
    const raw = Number(window.localStorage.getItem(SEQ_KEY))
    const next = (Number.isFinite(raw) && raw >= 0 ? raw : 0) + 1
    window.localStorage.setItem(SEQ_KEY, String(next))
    return next
  } catch {
    return Math.floor(Date.now() / 1000) % 1_000_000
  }
}

/** Next display code for new discount headers (local sequence). */
export function nextDiscountCode(): string {
  return `DIS-${String(bumpSeq()).padStart(5, '0')}`
}
